// Sets the input value to the provided nutrient and also limits the length of the input
export const setValueAndMaxLength = (e, callback, maxLength) => {
  if (e.target.value.length > maxLength) {
    callback(e.target.value.slice(0, maxLength));
  } else {
    callback(e.target.value);
  }
};
